import { create } from "zustand";

type User = {
  name: string;
  email: string;
  mobile: string;
  profileImage: string;
  state: string;
  isBlocked: boolean;
} | null;

type Store = {
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User) => void;
  setAuthenticated: (isAuthenticated: boolean) => void;
};

// export const useStore = create<{

//   user: User | null;

//   setUser: (user: User | null) => void;

// }>((set) => ({

//   user: null,

//   setUser: (user) => set({ user }),

// }));

export const useStore = create<Store>((set) => ({
  user: {
    name: "",
    email: "",
    mobile: "",
    profileImage: "",
    state: "",
    isBlocked: false,
  },
  isAuthenticated: false,
  setUser: (user) => set({ user }),
  setAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
}));
